import { render, staticRenderFns } from "./Reference.vue?vue&type=template&id=0824d901&scoped=true"
import script from "./Reference.vue?vue&type=script&lang=js"
export * from "./Reference.vue?vue&type=script&lang=js"
import style0 from "./Reference.vue?vue&type=style&index=0&id=0824d901&prod&lang=scss&scoped=true"
import style1 from "./Reference.vue?vue&type=style&index=1&id=0824d901&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0824d901",
  null
  
)

export default component.exports